var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AuthContainer',{attrs:{"className":'login-container'}},[_c('AuthCard',[_c('LoginForm',{attrs:{"loading":_vm.loading},on:{"nextStep":_vm.login}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }